import { useState, useEffect } from 'react';

const DEBOUNCE_MS = 500;

type DebounceReturnType = {
  debouncedValue: string,
  isDebouncing: boolean,
}

export default function useDebounce(value: string): DebounceReturnType {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [isDebouncing, setIsDebouncing] = useState(false);

  useEffect(() => {
    setIsDebouncing(true);
    const handler: NodeJS.Timeout = setTimeout(() => {
      setDebouncedValue(value);
      setIsDebouncing(false);
    }, DEBOUNCE_MS);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return {
    debouncedValue,
    isDebouncing,
  };
}
